import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import { isFunction } from '@src/utils/type-utils';

export default class extends BaseModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;
  @observable clickBacktopCallback = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  onClickBackTop = () => {
    this.onClickClose();
    isFunction(this.clickBacktopCallback) && this.clickBacktopCallback();
  };

  use() {
    super.use();
  }
}
